import React, { useState } from "react";
import { Backdrop, Button, FormFieldSet, LogoLoader, showToast, useFormHandler } from "../../../../components";
import { useSelector } from "react-redux";
import { addLeadJob } from "../../../../redux/slices/bdmjobs/bdmjobsApi";

const AddJobModal = ({ companyUiid, onCancel, onSuccess }) => {
    const [loading, setLoading] = useState(false);
    const { user } = useSelector((state) => state.auth);
    const validationRules = {
        jobTitle: {
            type: "text",
            required: true,
        },
        location: {
            type: "object",
            required: true,
        },
        jobUrl: {
            type: "text",
            required: true,
        },
    };

    const initialFormData = {
        jobTitle: "",
        // location: "",
        location: {
            uiValue: "",
            address: "",
        },
        jobUrl: "",
        applicantsApplied: "",
        jobPoster: "",
        designation: "",
        status: 1,
        postedDuration: "",
        rate: "",
    };

    const { formData, errors, handleChange, validateAllFields, setFormData } =
        useFormHandler(initialFormData, validationRules);

    const handleSubmit = async () => {
        if (!validateAllFields()) return;
        if (!companyUiid) {
            showToast("CompanyId is required!", "error");
            return;
        }

        try {
            setLoading(true);

            const payload = {
                coll: "LeadJob",
                payload: {
                    jobTitle: formData.jobTitle,
                    companyId: companyUiid,
                    status: formData.status,
                    //   location: {
                    //     city: formData.location?.city,
                    //     state: formData.location?.state,
                    //   },
                    location: formData.location.address,
                    jobUrl: formData.jobUrl,
                    noOfApplicants: formData.applicantsApplied,
                    rate: formData.rate,
                    posterName: formData.jobPoster,
                    posterTitle: formData.posterTitle,
                    postedDuration: formData.postedDuration,
                    addedBy: user?.data?.uiid,
                },
            };
            const res = await addLeadJob(payload);
            if (res?.data) {
                onCancel();
                onSuccess?.();
                showToast("Job Added Successfully", "success");
            } else {
                showToast("Failed to add job", "error");
            }
        } catch (err) {
            console.error("Failed to add job", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col gap-5 p-4 sm:p-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
                <FormFieldSet
                    type="text"
                    title="Job Title"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.jobTitle}
                    onChange={(value) => handleChange("jobTitle", value)}
                    error={errors.jobTitle}
                    required
                />

                {/* <FormFieldSet
                    type="atscitiesState"
                    title="Location"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.location}
                    // onChange={(value) => {
                    //     handleChange("location", value)
                    //     console.log("val",value)
                    // }}
                    onChange={(option) => {
                        if (!option) {
                            handleChange("location", null);
                            return;
                        }
                        const value = option.value || "";
                        console.log("value",value)
                        if (value.includes("-")) {
                            const [city, state] = value.split("-").map(v => v.trim());

                            handleChange("location", {
                                city,
                                state,
                            });
                        }
                        else {
                            handleChange("location", {
                                state: value,
                            });
                        }
                    }}
                    error={errors.location}
                    required
                    parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
                    showSearch
                /> */}
                <FormFieldSet
                    type="atscitiesState"
                    title="Location"
                    placeholder="Enter"
                    shadow
                    value={formData.location.uiValue}
                    error={errors.location}
                    required
                    parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
                    showSearch
                    onChange={(option) => {
                        if (!option) {
                            handleChange("location", {
                                uiValue: null,
                                address: null,
                            });
                            return;
                        }

                        const value = option.value || "";

                        let address = {
                            country: null,
                            state: null,
                            city: null,
                            zipCode: null,
                        };

                        if (value.includes("-")) {
                            const [city, state] = value.split("-").map(v => v.trim());
                            address.city = city;
                            address.state = state;
                        } else {
                            address.state = value;
                        }

                        handleChange("location", {
                            uiValue: option,   // ✅ keeps input happy
                            address,           // ✅ backend-ready
                        });
                    }}
                />


                <FormFieldSet
                    type="text"
                    title="Job URL"
                    shadow={true}
                    placeholder="Enter"
                    value={formData.jobUrl}
                    onChange={(value) => handleChange("jobUrl", value)}
                    error={errors.jobUrl}
                    required
                />
                <FormFieldSet
                    type="text"
                    title="Posted Duration"
                    shadow={true}
                    placeholder="Enter"
                    value={formData.postedDuration}
                    onChange={(value) => handleChange("postedDuration", value)}
                    error={errors.postedDuration}
                />

                <FormFieldSet
                    type="text"
                    title="No. of Applicants Applied"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.applicantsApplied}
                    onChange={(value) => handleChange("applicantsApplied", value)}
                    error={errors.applicantsApplied}
                />

                <FormFieldSet
                    type="text"
                    title="Job Poster name"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.jobPoster}
                    onChange={(value) => handleChange("jobPoster", value)}
                    error={errors.jobPoster}
                />

                <FormFieldSet
                    type="text"
                    title="Poster Title"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.posterTitle}
                    onChange={(value) => handleChange("posterTitle", value)}
                    error={errors.posterTitle}
                    className="sm:col-span-2 lg:col-span-1"
                />
                <FormFieldSet
                    type="text"
                    title="Rate"
                    placeholder="Enter"
                    shadow={true}
                    value={formData.rate}
                    onChange={(value) => handleChange("rate", value)}
                    error={errors.rate}
                    className="sm:col-span-2 lg:col-span-1"
                />
                <FormFieldSet
                    type="select"
                    title="Status"
                    size="md"
                    options={[
                        { label: "Active", value: 1 },
                        { label: "Positive", value: 2 },
                        { label: "Open", value: 3 },
                        { label: "On Hold", value: 4 },
                        { label: "Hold by Client", value: 5 },
                        { label: "Interview L1", value: 6 },
                        { label: "Interview L2", value: 7 },
                        { label: "Interview L3", value: 8 },
                        { label: "Priority", value: 9 },
                        { label: "Filled", value: 10 },
                        { label: "Closed", value: 11 },
                        { label: "Agreement Sent", value: 12 },
                        { label: "Agreement Accepted", value: 13 },
                    ]}
                    showSearch
                    value={formData?.status}
                    onChange={(v) => handleChange("status", v)}
                />
            </div>

            <div className="flex flex-col-reverse sm:flex-row justify-end items-center gap-3 mt-2">
                <Button
                    variant="outlined"
                    title="Cancel"
                    color="black"
                    onClick={() => onCancel()}
                    className="w-full sm:w-auto"
                />
                <Button
                    title={loading ? "Saving..." : "Save"}
                    variant="contained"
                    color="primary"
                    className="w-full sm:w-auto"
                    onClick={handleSubmit}
                    disabled={loading}
                />
            </div>
            <Backdrop isOpen={loading}>
                <LogoLoader />
            </Backdrop>
        </div>
    );
};

export default AddJobModal;